import React, { useMemo, useRef, useState } from 'react';
import CardCom from '../../../components/CardCom/index.jsx';
import { cn, copyToClipboard } from '../../../utils/utils';

import { ReactComponent as ReportSvg } from '../../../assets/svgs/report.svg';
import { ReactComponent as Share2Svg } from '../../../assets/svgs/share2.svg';

import SvgCom from '../../../components/SvgCom/index.jsx';

import { ReactComponent as AddSvg } from '../../../assets/svgs/add.svg';

import { ReactComponent as Add2Svg } from '../../../assets/svgs/add2.svg';
import { ReactComponent as CopySvg } from '../../../assets/svgs/copy.svg';
import AddShowreelWinCom from './AddShowreelWinCom.jsx';
import moment from 'moment';
import { message } from 'antd';

const InsightCom = ({insightList = [], proDesc = ''}) => {
  const [ showWin, setShowWin ] = useState(false);
  const [ clipIds, setClipIds ] = useState([]);

  const fnOnAddChange = (type, clipId, clips = []) => {
    if(type === 'all') {
      const tempClipIds = clips.map(item => item.id);
      setClipIds(tempClipIds);
    } else {
      setClipIds([clipId]);
    }
    setShowWin(true);
  };

  return (
    <>
      <div className={cn('grid gap-4')}>
        <CardCom label="Project Details" rightNode={
          <div className="flex items-center">
            <div className="flex items-center mr-6 cursor-pointer">
              <SvgCom Svg={ReportSvg} size="14"></SvgCom>
              <span className="text-sm leading-none text-primary ml-2">Reporting</span>
            </div>
            <div className="flex items-center cursor-pointer">
              <SvgCom Svg={Share2Svg} size="14"></SvgCom>
              <span className="text-sm leading-none text-primary ml-2">Share</span>
            </div>
          </div>
        }>
          <div className="text-sm text-primary font-semibold">
            {proDesc}
          </div>
        </CardCom>
        {
          insightList.map((item, index) => <TaskItemCom key={index} detail={item} onAddChange={(type, clipId) => fnOnAddChange(type, clipId, item.clips)}></TaskItemCom>)
        }
      </div>
      <AddShowreelWinCom clipIds={clipIds} openWin={showWin} onClose={setShowWin}></AddShowreelWinCom>
    </>
  );
};

const TaskItemCom = ({detail, onAddChange}) => {
  const videoRef = useRef(null);

  const copyText = async (text) => {
    try {
      await copyToClipboard(text);
      message.success('Copid');
    } catch(error) {
      //
    }
  };

  const fnPlay = (playTime) => {
    if(videoRef && videoRef.current) {
      videoRef.current.currentTime = playTime;
    }
  };

  const sortClips = useMemo(() => {
    const tempClips = detail.clips;
    tempClips.sort((a, b) => a.duration - b.duration);
    return tempClips;
  }, [detail]);

  return <CardCom label={detail.topic}>
    <div className="text-sm font-normal text-green-1 mb-[20px]">
      {detail.summary}
    </div>

    <div className="flex justify-start">
      <div>
        <video ref={videoRef} className="w-[350px]" autoPlay={false} muted loop controls src={detail.video_url} preload="true"></video>
      </div>
      <div className="flex-1 ml-[20px]">
        {/* <div className="text-lg font-bold text-primary mb-[20px]">
            Importance of using a variety of seasonings and marinades.
        </div> */}
        {
          sortClips.map((item, index) => <div key={index} className="flex justify-start text-sm mb-2">
            <span onClick={() => fnPlay(item.duration)} className=" cursor-pointer h-fit leading-none font-semibold text-primary py-[4px] px-[8px] bg-second rounded-[5px]">{moment.utc( item.duration * 1000).format('mm:ss')}</span>
            <div>
              <span className="text-grey-3 mx-2">{`"${item.content}"`}</span>
              <SvgCom onClick={() => onAddChange('one', item.id)} Svg={Add2Svg} size="14" className="cursor-pointer inline-block mr-1"></SvgCom>
              <SvgCom onClick={() => copyText(item.content)} Svg={CopySvg} size="14" className="cursor-pointer inline-block text-primary"></SvgCom>
            </div>
          </div>)
        }

        {/* <div className="text-base leading-none font-bold text-green-1 mt-[25px]">Follow up question</div>
        <div className="text-sm font-semibold text-green-1 my-[10px]">What types of seasonings and marinades do you find most effective for enhancing the flavor of your barbecue?</div> */}

        <button onClick={() => onAddChange('all')} className="mt-5 border-btn !border-transparent !bg-second !text-primary !font-semibold">
          <SvgCom Svg={AddSvg} size="16"></SvgCom>
          <span className="ml-2">Add all showreel</span>
        </button>
      </div>
    </div>
  </CardCom>;
};

export default InsightCom;